import { WorkLocationFragment } from '@alice-financial/alice-sdk'
import { Button } from '@alice-financial/pretext-ui'
import PeopleIcon from '@mui/icons-material/People'
import * as React from 'react'
import { PaygroupForm } from './PaygroupForm'

type AssignPaygroupsButtonProps = {
  editable?: boolean
  location: WorkLocationFragment
}
export const AssignPaygroupsButton: React.FC<AssignPaygroupsButtonProps> = ({ editable, location }) => {
  const [open, setOpen] = React.useState(false)
  const payGroups = location.employersInfo || []
  if (!editable && payGroups.length === 0) return null
  return (
    <>
      <Button
        size="small"
        color="primary"
        variant={payGroups.length === 0 ? 'contained' : 'outlined'}
        onClick={() => setOpen(true)}
        startIcon={<PeopleIcon />}
        sx={{ textWrap: 'nowrap' }}
      >
        {payGroups.length === 0 ? 'Assign pay group' : 'Edit pay groups'}
      </Button>
      <PaygroupForm open={open} onClose={() => setOpen(false)} location={location} />
    </>
  )
}
